/**
 * VoPay sometimes appends "?Token=..." to a redirect URL that already contains "?",
 * producing invalid URLs like /path?vopay_callback=1?Token=... — URLSearchParams may miss Token.
 * This extracts Token/token from the raw href.
 */
export function extractVopayTokenFromHref(href) {
  if (!href || typeof href !== 'string') return '';
  const m = href.match(/(?:[?&])Token=([^&]+)/i) || href.match(/(?:[?&])token=([^&]+)/);
  try {
    return m ? decodeURIComponent(m[1]) : '';
  } catch {
    return m ? m[1] : '';
  }
}

export const VOPAY_PENDING_SYNC_KEY = 'vopay_pending_sync';
export const VOPAY_SYNC_PROCESSING_KEY = 'vopay_sync_processing';
